<template>
  <div>
    <div class="serchBox">
      <!-- <div class="logoImg img">
        <img src="../../assets/img/logo-p.png" alt="" srcset="" />
      </div> -->
      <div class="inpBox">
        <div class="inp">
          <div class="search">
            <div class="iconfont icon-search"></div>
          </div>
          <div class="shu"></div>
          <input type="text" placeholder="请输入学校名称搜索" v-model="searChTxt" @keyup.enter="searchClick" name="" id="" />
          <div class="searchBtn" @click="searchClick">搜索</div>
        </div>
      </div>
    </div>
    <div class="content">
      <div class="leftCont">
        <div class="typeList">
          <div
            class="type"
            :class="item.id == typeOn ? 'on' : ''"
            v-for="item in typeList"
            @click="typeClick(item.id)"
          >
            {{ item.name }}
          </div>
        </div>
        <Kong v-if="list.length == 0" />
        <div class="cont" @click="jump(item.id)" v-for="item in list">
          <div class="name">{{ item.name }}</div>
          <div class="text c-2" v-html="item.content"></div>
          <div class="time">{{ item.create_time }}</div>
        </div>
        <div class="fenye" v-if="totalCount > 10">
          <a-pagination
            :default-current="page.pageNo"
            v-model="page.pageNo"
            :total="totalCount"
            :page-size="10"
            @change="pageOnChange"
          />
        </div>
      </div>
      <div class="rightCont">
        <LoginZj />
        <div class="cont" v-if="qyList">
          <div class="contHead">
            <div class="name">最新招聘</div>
            <!-- <div class="iconfont icon-enter"></div> -->
          </div>
          <div class="contList">
            <div class="li" v-for="item in qyList" v-html="item.name"></div>
          </div>
        </div>
        <div class="cont" v-if="zfList">
          <div class="contHead">
            <div class="name">新闻资讯</div>
            <!-- <div class="iconfont icon-enter"></div> -->
          </div>
          <div class="contList">
            <div class="li" v-for="item in zfList" v-html="item.name"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Kong from "../component/kong.vue";
import LoginZj from "../component/loginZj.vue";

export default {
  components: {
    Kong,
    LoginZj,
  },
  name: "",
  data() {
    return {
      typeOn: "",
      typeList: [],
      judge: true,
      page: {
        pageNo: 1,
        pageSize: 10,
        name:''
      },
      list: [],
      totalCount: 0,
      qyList: [],
      zfList: [],
      searChTxt: "",
    };
  },
  created() {
    this.typeGet();
    this.qyGet();
    this.zfGet();
  },
  activated() {
    if (this.$route.query.id) {
      this.typeGet();
    }
  },
  methods: {
    searchClick() {
      this.page.name = this.searChTxt;
      this.page.pageNo = 1;
      this.totalCount = 0;
      this.listGet();
    },
    qyGet() {
      this.$get("/nozzle/web/news_gets", {
        pageNo: 1,
        pageSize: 5,
        config_id: 104,
        name:this.page.name
      }).then((res) => {
        console.log(res.data);
        this.qyList = res.data;
      });
    },
    zfGet() {
      this.$get("/nozzle/web/news_gets", {
        pageNo: 1,
        pageSize: 5,
        config_id: 160,
      }).then((res) => {
        console.log(res.data);
        this.zfList = res.data;
      });
    },
    listGet() {
      if (!this.judge) {
        return;
      }
      this.judge = false;
      this.$get("/nozzle/web/news_gets", this.page).then((res) => {
        console.log(res);
        this.judge = true;
        if (this.totalCount == 0) {
          this.totalCount = res.totalCount;
        }
        if (res.data) {
          for (let i = 0; i < res.data.length; i++) {
            const e = res.data[i];
            e.create_time = this.$moment(e.create_time).format("YYYY年M月D日");
            e.content = e.content
              .replace(/<[^<>]+>/g, "")
              .replace(/&nbsp;/gi, "")
              .replace(/\s/g, "");
          }
          this.list = res.data;
        } else {
          this.list = [];
        }
      });
    },
    typeGet() {
      this.$get("/common/configuration_gets", {
        type: "news",
      }).then((res) => {
        this.typeList = res.data;
        this.typeList.unshift({
          name: "全部新闻",
          id: "",
        });
        console.log(this.$route.query.id);

        this.typeOn =
          this.$route.query.id == 0 || !this.$route.query.id
            ? ""
            : this.$route.query.id;
        console.log(this.typeOn);
        this.page.config_id =
          this.$route.query.id == 0 || !this.$route.query.id
            ? ""
            : this.$route.query.id;
        this.$forceUpdate();
        this.listGet();
      });
    },
    pageOnChange(i) {
      this.page.pageNo = i;
      this.listGet();
    },
    typeClick(id) {
      this.typeOn = id;
      this.page.config_id = id;
      this.page.pageNo = 1;
      this.totalCount = 0;
      this.list = [];
      this.listGet();
    },
    jump(id) {
      // this.$router.push({
      //   path: "/newsCont",
      //   query: {
      //     id,
      //   },
      // });
      window.open("#/newsCont?id=" + id);
    },
  },
  mounted() {},
  computed: {},
};
</script>

<style lang="less" scoped>
.serchBox {
  display: flex;
  justify-content: center;
  padding: 25px 55px;
  padding-right: 70px;
  padding-bottom: 5px;
  align-items: center;
  width: 1280px;
  margin: auto;
  box-sizing: border-box;
  .logoImg {
    width: 150px;
  }

  .inpBox {
    width: calc(100% - 70px);
    box-sizing: border-box;

    .inp {
      border: 2px solid #1a78ec;
      background-color: #fff;
      width: 100%;
      height: 50px;
      border-radius: 10px;
      display: flex;
      overflow: hidden;
      align-items: center;
      position: relative;

      .search {
        width: 65px;
        display: flex;
        align-items: center;
        justify-content: center;
        height: 100%;

        .iconfont {
          font-size: 24px;
          color: #999;
        }
      }

      .shu {
        width: 2px;
        height: 20px;
        background-color: #c9c9c9;
      }

      input {
        width: calc(100% - 67px);
        height: 100%;
        padding-left: 20px;
        box-sizing: border-box;
      }

      .searchBtn {
        cursor: pointer;
        width: 90px;
        height: calc(100% - 4px);
        position: absolute;
        right: 2px;
        top: 2px;
        background-color: #1a78ec;
        color: #fff;
        font-weight: 600;
        font-size: 16px;
        border-radius: 5px;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
  }
}
.content {
  width: 1280px;
  margin: auto;
  overflow: hidden;
  padding-top: 20px;
  display: flex;

  .leftCont {
    overflow: hidden;
    width: calc(100% - 360px);

    .typeList {
      display: flex;
      height: 60px;
      font-size: 16px;
      background-color: #fff;
      margin-bottom: 10px;
      overflow: hidden;
      border-radius: 10px;

      .type {
        box-sizing: border-box;
        height: 100%;
        width: 130px;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
      }

      .on {
        font-weight: 600;
        border-bottom: 2px solid #1677ff;
        color: #1677ff;
      }
    }

    .cont {
      cursor: pointer;
      background-color: #fff;
      border-radius: 15px;
      margin-bottom: 10px;
      padding: 20px;

      // width: calc(50% - 7.5px);
      // margin-right: 15px;
      // float: left;
      .name {
        font-weight: 600;
        font-size: 18px;
      }

      .text {
        margin-top: 10px;
        font-size: 16px;
        color: #333;
      }

      .time {
        margin-top: 10px;
      }
    }

    .cont:nth-child(2n) {
      margin-right: 0;
    }
  }

  .rightCont {
    width: 360px;
    padding-left: 15px;

    .cont {
      background-color: #fff;
      border-radius: 10px;
      margin-bottom: 10px;

      .contHead {
        padding: 15px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        border-bottom: 1px solid #ebebeb;

        .name {
          font-weight: 600;
        }

        .iconfont {
          font-size: 14px;
          color: #9c9c9c;
        }
      }

      .contList {
        padding: 15px;

        .li {
          padding-bottom: 15px;
        }

        .li:last-child {
          padding-bottom: 0;
        }
      }
    }
  }
}
</style>
